import React from 'react';

import * as Styled from './divider.style';

export type DividerProps = {
  className?: string;
};

export const Divider: React.FC<DividerProps> = ({ className }) => (
  <Styled.Divider className={className} />
);
